import { ref, readonly } from 'vue'

/**
 * Replacement for old admin's `Vue.prototype.locale` / `window.locale` global
 * (set by settings.onLocaleChange in main.ts). Read by OrderList and the legal
 * print templates (ReceiptInvoiceSr/Me/Ba, ReceiptCreditNote) — audit finding F7.
 *
 * window.locale is still mirrored in main.ts for parity; in-app code should use
 * this reactive ref instead of the global.
 */
const locale = ref<string>('en')

export function setCurrentLocale(value: string) {
    locale.value = value
}

export function useLocale() {
    return { locale: readonly(locale) }
}
